import React, { useCallback, useEffect } from 'react';
import { Input, Tag, Tooltip } from 'antd';
import { filterOptions } from 'modules/dashboard/search/constants';
import NewRecord from 'modules/dashboard/form';
import Results from 'modules/dashboard/search/Results';
import Request from 'common/network/Request';
import dashboardApis from 'modules/dashboard/api';
import { MeetingNumbers } from 'modules/meeting-history/context';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive';

const Search = () => {
  const isSmallScreen = useMediaQuery({ maxWidth: 768 });

  const [results, setResults] = React.useState([]);
  const [searchParams, setSearchParams] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [filtersSelected, setFiltersSelected] = React.useState([]);

  const searchParamsStringify = JSON.stringify(searchParams);

  const getData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await Request.get(
        dashboardApis.get_candidates,
        JSON.parse(searchParamsStringify),
      );
      setResults(response?.result || []);
    } catch (error) {}
    setLoading(false);
  }, [searchParamsStringify]);

  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    setSearchParams((prev) => ({
      ...prev,
      filters_selected: filtersSelected,
    }));
  }, [filtersSelected]);

  const handleSearch = (value) => {
    setSearchParams((prev) => ({
      ...prev,
      text: value,
    }));
  };

  const handleSelectOption = (key, checked) => {
    const nextSelectedKeys = checked
      ? [...filtersSelected, key]
      : filtersSelected.filter((t) => t !== key);
    setFiltersSelected(nextSelectedKeys);
  };

  return (
    <MeetingNumbers.Provider value={{}}>
      <div className="flex justify-between items-center gap-2">
        <Input.Search
          placeholder="Tìm kiếm nhanh theo tên hoặc SĐT"
          allowClear
          onSearch={handleSearch}
          className="md:flex-initial w-2/5 flex-1"
          size={isSmallScreen ? 'middle' : 'large'}
          enterButton
        />
        <NewRecord onSuccess={getData} />
      </div>
      <div className="mt-4">
        <p className="text-base">
          Hiển thị theo bộ lọc{' '}
          <Tooltip title="Bấm vào từng thẻ để lọc theo điều kiện">
            <ExclamationCircleOutlined className="cursor-help" />
          </Tooltip>
        </p>

        <div className="flex gap-2 flex-wrap mt-2">
          {Object.entries(filterOptions).map(([key, value]) => {
            const isSelected = filtersSelected.includes(key);

            return (
              <Tag.CheckableTag
                key={key}
                checked={isSelected}
                onChange={(checked) => handleSelectOption(key, checked)}
                bordered={isSelected}
                className={`${!isSelected ? 'border border-gray-300' : ''} px-2 py-1 md:px-4 md:py-2 me-0`}
              >
                {value}
              </Tag.CheckableTag>
            );
          })}
        </div>
      </div>
      <div className="mt-6">
        <Results
          results={results}
          loading={loading}
          onChangePagination={setSearchParams}
          refetch={getData}
        />
      </div>
    </MeetingNumbers.Provider>
  );
};

export default Search;
